<template>
  <div class="inform-center">
    <a-tabs
      v-model="tablekey"
      :tabBarGutter="10"
      @change="tabChange"
    >
      <a-tab-pane
        v-for="item in tableList"
        :key="item.tabKey"
        :style="{ width: '100px' }"
        :disabled="item.disabled"
      >
        <template #tab>
          <a-badge
            :count="item.tabAccount"
            :overflow-count="99"
            :offset="[10, -5]"
          >
            {{item.tabName}}
          </a-badge>
        </template>
      </a-tab-pane>
    </a-tabs>
    <div class="inform-body">
      <ul v-if="informList.length > 0">
        <li
          v-for="(item, index) in informList"
          :key="index"
        >
          <div class="inform-item">
            <div class="task-type-box">
              <span class="title">{{item.categories.length > 1 ? item.categories[1].name : 'null'}}</span>
              <span
                class="task-operate"
                @click="markAsRead(item)"
              >标记为已读</span>
            </div>
            <div class="content">
              <span class="content-mark">{{item.title}} <span
                  class="task-urgent"
                  v-if="item.isUrgent"
                >{{urgentS[item.isUrgent]}}</span></span>
              <div class="content-explain">
                <img
                  :src="item.params && item.params.picture"
                  v-show=" item.params && item.params.picture "
                />
                <p class="content-text">{{ item.params && item.params.publisher ? `【${item.params.publisher}】发布了一则关于${item.content}` : item.content}}</p>
                <span
                  class="to-detail"
                  @click="toDetail(item)"
                  v-if="(item.url && item.url!='') || item.title == '工作流引擎'"
                >详情&thinsp;
                  <a-icon
                    :style="{ fontSize: '12px'}"
                    type="right"
                  />
                </span>
              </div>
            </div>
            <div class="project-box">
              <span class="time-warning">{{item.createdAt}}</span>
              <span class="project-name">{{item.projectName || '暂无项目'}}</span>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="empty-data"
        v-else
      >
        <img
          src="~@/assets/images/informCenter/emptyData.png"
          :style="{width: '228px', height: '147px'}"
        />
        <span>暂无消息</span>
      </div>
      <div
        class="search-all"
        @click.prevent="showAllInform"
      >查看全部</div>
    </div>
  </div>
</template>

<script>
import { timeSetting } from './timeSetting' // 时间转化的接口
import { tabsList as tableList, urgentS } from './index'
import { messageListAPi, messageAccountAPi, readedApi, readedOneApi } from '@/api/infromCenter'
import { getStore } from '@/utils/storage'
export default {
  name: 'InformCenter',
  data () {
    return {
      tablekey: 'alarm',
      tableList,
      informList: [],
      urgentS
    }
  },
  mounted () {
    this.getMessageList()
    this.getMessageAccount()
  },
  methods: {
    tabChange (ev) {
      console.log(ev, 'tabsKeys')
      this.getMessageList()
    },
    showAllInform () {
      this.$emit('goDetail')
      window.history.pushState({}, '', '/main/informCenter')
    },
    async toDetail ({ url, id, title, params }) {
      // 如果是工作流的标识,则需要自己拼接跳转的参数
      if ((url && id) || title == '工作流引擎') {
        const { code } = await readedOneApi(id)
        if (code === 1000) {
          this.$emit('goDetail')
          if (title != '工作流引擎') {
            window.history.replaceState({}, '', url)

          } else {
            if (params && params.id) {
              window.history.replaceState({}, '', `/approvalManagement/approvalCenter/detail?processInstanceId=${params.processInstanceId}&id=${params.id}&processDefinitionId=${params.processDefinitionId}`)
              // window.history.replaceState({}, '', `/approvalManagement/approvalCenter/detail?processInstanceId=${params.processInstanceId}&id=${params.id}&processDefinitionId=${params.processDefinitionId}&key=_2023072024304437&boradChoose=0`)
            } else {
              this.$message.error('跳转详情页面失败，请检查参数是否正确！')
            }

          }
          // 这段代码按道理没有存在的必要，是不是copy多了？先注释掉吧，因为产生了bug又没看出实际意义
          // let getLinkCode = getStore('setLinkCode')
          // if (getLinkCode && getLinkCode !== 'undefined') {
          //   window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
          // } else {
          //   // 预发环境 这里reload 会跳转到首页 先注释把
          //   // window.location.reload()
          // }
        } else {
          this.$message.error('信息有误，请联系管理员查看原因！')
        }
      } else {
        this.$message.error('跳转详情页面失败，请检查跳转链接是否正确！')
      }
    },
    async getMessageAccount () {
      const data = {
        categoryCode: [],
        channels: ['WEBSOCKET'],
        isRead: false
      }
      data.categoryCode = tableList.map(tab => {
        return tab.tabKey
      })
      const { code, result, message } = await messageAccountAPi(data)

      if (code === 1000) {
        tableList.forEach(item => {
          item.tabAccount = result[item.tabKey]
        })
        this.$store.dispatch('messageCenterCount', result.total)
      } else {
        this.$message.warning(message)
      }
    },
    async getMessageList () {
      const data = {
        current: 1,
        size: 4,
        isRead: false,
        channels: ['WEBSOCKET'],
        categoryCode: [this.tablekey]
      }
      const { code, message, result } = await messageListAPi(data)
      if (code === 1000) {
        this.informList = result.records.map(item => {
          return {
            ...item,
            createdAt: timeSetting(item.createdAt)
          }
        })
      } else {
        this.$message.warning(message)
      }
    },
    async markAsRead (item) {
      // const data = [item.id]
      const { code, message } = await readedOneApi(item.id)
      if (code === 1000) {
        this.$message.success('操作成功')
        this.getMessageList()
        this.getMessageAccount()
      } else {
        this.$message.warning(message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .business-tabs-nav .business-tabs-tab:hover{
  color: var(--theme-color) !important;
}
/deep/ .business-tabs-nav .business-tabs-tab-active{
  color: var(--theme-color) !important;
}
/deep/ .business-tabs-ink-bar{
  background-color: var(--theme-color) !important;
}
.inform-center {
  .task-urgent {
    border: 1px solid #f5222d;
    border-radius: 2px;
    color: var(--theme-color) !important;
    font-size: 12px;
    height: 20px;
    width: 40px;
    line-height: 20px;
    padding: 0 8px;
    margin-left: 16px;
  }
  .inform-body {
    position: relative;
    .search-all-disable {
      height: 58px;
      line-height: 58px;
      position: absolute;
      left: -18px;
      right: -18px;
      top: 414px;
      background: #fff;
      text-align: center;
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      font-size: 18px;
      color: #d9d9d9;
      cursor: pointer;
    }
    .search-all {
      height: 58px;
      line-height: 58px;
      position: absolute;
      left: -18px;
      right: -18px;
      top: 414px;
      background: #fff;
      text-align: center;
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      font-size: 18px;
      color: var(--theme-color) !important;;
      cursor: pointer;
    }
    .empty-data {
      height: 410px;
      width: 328px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 0 auto;
      span {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.35);
      }
    }
    ul {
      background: #fff;
      height: 460px;
      width: 100%;
      overflow-y: auto;
      padding-right: 2px;
      padding-bottom: 60px;
    }
    .inform-item {
      border: solid 1px #f0f0f0;
      background: #fff;
      margin-bottom: 12px;
      height: 197px;
      .task-type-box {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        height: 48px;
        align-items: center;
        background: #fafafa;
        padding: 12px;
        color: #8c8c8c;
        .title {
          font-size: 16px;
        }
        .task-operate {
          cursor: pointer;
          font-size: 12px;
          &:hover {
            color: var(--theme-color) !important;
          }
        }
      }
      display: flex;
      flex-direction: column;
      width: 100%;
      .content {
        display: flex;
        flex-direction: column;
        height: 360px;
        padding: 14px 16px 20px 16px;
        .content-mark {
          color: #262626;
          font-size: 16px;
          margin-bottom: 9px;
        }
        .content-explain {
          color: #8c8c8c;
          display: flex;
          align-items: flex-start;
          height: 44px;
          width: 328px;
          position: relative;
          img {
            width: 81px;
            height: 52px;
          }
          .content-text {
            flex: 1;
            margin-left: 16px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .to-detail {
            font-size: 14px;
            cursor: pointer;
            margin-top: 22px;
            color: var(--theme-color) !important;;
          }
        }
      }
      .project-box {
        height: 38px;
        line-height: 38px;
        padding: 0 16px;
        border-top: 1px solid #f0f0f0;
        display: flex;
        justify-content: space-between;
        span {
          color: #8c8c8c;
          font-size: 12px;
        }
      }
    }
  }
}
</style>